/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createLoadingSelector, createErrorSelector, errorActions } from "@a1/core";
import { processActions } from "../../reducer/processReducer";

import logoSplash from "../../images/logo_splash.png";

const actionsNames = ["CHANGE_PASS_CHECK_EMAIL"];

class ChangePass extends Component {
  state = {
    email: "",
    emailError: "",
    mustValidateData: false,
  };

  componentDidMount() {
    document.title = "Смяна на парола - A1 Xplore TV GO";

    const { process, clearErrors, changePassResetResults } = this.props;

    clearErrors(actionsNames);

    if (process.changePassCheckEmailResult) {
      changePassResetResults();
    }

    this.handleAutofocus();
  }

  componentDidUpdate(prevProps) {
    const { history, loading, process, error } = this.props;

    if (
      !loading &&
      !(error && error.length) &&
      !(process.changePassCheckEmailResult && process.changePassCheckEmailResult.error)
    ) {
      // Typical usage (don't forget to compare props):
      if (
        process.changePassCheckEmailResult &&
        process.changePassCheckEmailResult !== prevProps.process.changePassCheckEmailResult &&
        process.changePassCheckEmailResult.isOk === true
      ) {
        history.push("/changepass-email");
        return false;
      }
    }

    this.handleAutofocus();
    return false;
  }

  handleInputChange = event => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    const { mustValidateData } = this.state;
    const { process, changePassResetResults } = this.props;
    if (process.changePassCheckEmailResult && process.changePassCheckEmailResult.error) {
      changePassResetResults();
    }

    this.setState({
      [name]: value,
    });

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleInputOnKeyUp = event => {
    const { mustValidateData } = this.state;

    if (event.keyCode === 13) {
      this.handleNextClick();
    }

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleAutofocus = () => {
    const autofocusElements = document.getElementsByClassName("autofocus");
    if (autofocusElements && autofocusElements.length > 0) {
      autofocusElements[0].focus();
    }
  };

  validateData = () => {
    const { email } = this.state;
    let isValid = false;

    if (email.length > 0) {
      const re = /^\S+@\S+\.\S+$/;
      if (re.test(email)) {
        isValid = true;
        this.setState({ emailError: "" });
      } else {
        this.setState({
          emailError:
            "Въведеният e-mail е грешен. Моля, въведи отново, като използваш само малки букви на латиница, без интервали.",
        });
      }
    } else {
      this.setState({
        emailError: "Въведи e-mail адрес, като използваш само малки букви на латиница, без интервали.",
      });
    }

    return isValid;
  };

  handleNextClick = () => {
    const { email, mustValidateData } = this.state;
    const { changePassResetResults, changePassSetEmail, changePassCheckEmail } = this.props;

    changePassResetResults();

    if (!mustValidateData) {
      this.setState({ mustValidateData: true });
    }

    if (this.validateData()) {
      changePassSetEmail(email);
      changePassCheckEmail(email);
    }
  };

  render() {
    const { email, emailError } = this.state;
    const { loading, error, process } = this.props;
    const requestError = error && error.length ? error.map(err => <p>{err}</p>) : null;

    let divError = null;

    if (requestError) divError = requestError;
    else if (emailError) divError = emailError;
    else if (process.changePassCheckEmailResult && process.changePassCheckEmailResult.error)
      divError = process.changePassCheckEmailResult.error;

    divError = divError ? <div className="error">{divError}</div> : null;

    const divLoading = loading ? (
      <div className="loading">
        <div className="spinner-border" />
      </div>
    ) : null;

    return (
      <div className="page page-login">
        <div className="header-bg" />

        <div className="container container--small">
          {divLoading}

          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>
          <div className="container-body">
            <h1 className="tag-title">Смяна на парола</h1>
            <div className="tag-content" style={{ marginBottom: "50px" }}>
              <p>Въведи e-mail адреса, който си посочил при регистрация.</p>
            </div>

            <div className="tag-textfield">
              <input
                type="text"
                name="email"
                id="email"
                className="autofocus tag-input"
                value={email}
                onChange={this.handleInputChange}
                onKeyUp={this.handleInputOnKeyUp}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
              />
              <label htmlFor="email">E-mail адрес</label>
            </div>

            {divError}

            <div className="tag-content" style={{ marginTop: "80px" }}>
              <button
                type="button"
                className="tag-btn tag-btn--active"
                onClick={this.handleNextClick}
                disabled={!!loading}
              >
                Продължи
              </button>
            </div>

            <div className="tag-content tag-content__help">
              Имаш въпроси?{" "}
              <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
                Помощ
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
    loading: createLoadingSelector(actionsNames)(state),
    error: createErrorSelector(actionsNames)(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearErrors: actions => dispatch(errorActions.clearErrors(actions)),
    changePassResetResults: () => dispatch(processActions.changePassResetResults()),
    changePassSetEmail: email => dispatch(processActions.changePassSetEmail(email)),
    changePassCheckEmail: email => dispatch(processActions.changePassCheckEmail(email)),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ChangePass);
